$(document).ready(function() {
  $(".brand-logo-slider").owlCarousel({
    items: 5,
    loop: false,
    nav: false,
    dots: false,
    margin: 10,
    responsive: {
      0: {
        items: 2,
        dots: true
      },
      749: {
        items: 3,
        dots: true
      },
      1200: {
        items: 5
      }
    }
  });
});
document.querySelectorAll(`.brand-item-image`).forEach(
    (item) => {
      item.addEventListener(`click`, (event) => {
        let args = new URLSearchParams(window.location.search)
        args.delete(`filter.p.vendor`)
        args.append(`filter.p.vendor`, [event.target.dataset.filterTarget])
        window.location.search = args
      })
    }
)
